import AddBoxIcon from '@mui/icons-material/AddBox';
// import AssignmentIcon from '@mui/icons-material/Assignment';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PollIcon from '@mui/icons-material/Poll';
import CheckIcon from '@mui/icons-material/Check';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import GroupIcon from '@mui/icons-material/Group';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PeopleIcon from '@mui/icons-material/People';

import { MenuItemType } from '../../components/types';

//import NewTransfer from '../../features/containers/newTransfer/NewTransfer';
// import OtherEntries from '../../features/containers/otherEntries/OtherEntries';
import LatestRequests from '../../features/transactions/agent/UserRequests';
import Reports from '../../features/reports/Reports';
import AllTransactions from '../../features/transactions/all/TransactionTable';
import PlatformClients from '../../features/platformClients/PlatformClientView';
import SatelliteAgents from '../../features/satelliteAgents/SatelliteAgents';
import Settings from '../../features/settings/Settings';
// import Actions from '../../features/containers/actions/Actions';
import PlatformClientDetails from '../../features/platformClients/PlatformClientDetails';
import RequestPage from '../../features/transactions/agent/RequestPage';
import ReportLoader from '../../features/reports/ReportLoader';
import ExchangeRates from '../../features/platformClients/rates/ExchangeRates';
import Services from '../../features/services/Services';
import ServiceIntakeForm from '../../features/services/ServiceIntakeForm';
import MyClientsView from '../../features/myClients/MyClientsView';

const menuItems: MenuItemType[] = [
  // {
  //   path: '/requests/new',
  //   title: 'New Transfer',
  //   icon: <AddBoxIcon />,
  //   page: <NewTransfer />,
  //   verifiedUsersOnly: true,
  //   isMenuItem: true,
  // },
  {
    path: '/request',
    title: 'New Transfer',
    icon: <AddBoxIcon />,
    page: <RequestPage requestType="TRANSFER" />,
    verifiedUsersOnly: true,
    isMenuItem: true,
  },
  {
    path: '/billrequest',
    title: 'New Bill',
    icon: <AddBoxIcon />,
    page: <RequestPage requestType="BILLPAY" />,
    verifiedUsersOnly: true,
    isMenuItem: false,
  },
  {
    path: '/request/:id',
    title: 'Request Details',
    page: <RequestPage requestType="TRANSFER" />,
    verifiedUsersOnly: true,
    isMenuItem: false,
  },
  {
    path: '/billrequest/:id',
    title: 'Bill Request Details',
    page: <RequestPage requestType="BILLPAY" />,
    verifiedUsersOnly: true,
    isMenuItem: false,
  },
  // {
  //   path: '/entries',
  //   title: 'Other Entries',
  //   icon: <AssignmentIcon />,
  //   page: <OtherEntries />,
  //   verifiedUsersOnly: true,
  //   isMenuItem: true,
  // },
  {
    path: '/requests',
    title: 'Latest Requests',
    icon: <ReceiptIcon />,
    page: <LatestRequests />,
    verifiedUsersOnly: true,
    isMenuItem: true,
  },
  {
    path: '/services',
    title: 'Services',
    icon: <ShoppingCartIcon />,
    page: <Services />,
    verifiedUsersOnly: true,
    isMenuItem: true,
  },
  {
    path: '/services/:type/:serviceid',
    title: 'Service Intake',
    page: <ServiceIntakeForm />,
    verifiedUsersOnly: true,
    isMenuItem: false,
  },
  {
    path: '/services/:type/:serviceid/:contract',
    title: 'Service Items',
    page: <ServiceIntakeForm />,
    verifiedUsersOnly: true,
    isMenuItem: false,
  },
  { path: 'divider', verifiedUsersOnly: true, isMenuItem: true },
  {
    path: '/my-customers',
    title: 'My Customers',
    icon: <PeopleIcon />,
    page: <MyClientsView />,
    verifiedUsersOnly: true,
    isMenuItem: true,
  },
  {
    path: '/receipt/:reportid/:id',
    title: 'Receipt Report',
    page: <ReportLoader />,
    verifiedUsersOnly: true,
    isMenuItem: false,
  },
  {
    path: '/reports/:reportid',
    title: 'Report Detail',
    page: <ReportLoader />,
    verifiedUsersOnly: true,
    isMenuItem: false,
  },
  {
    path: '/reports',
    title: 'Reports',
    icon: <PollIcon />,
    page: <Reports />,
    verifiedUsersOnly: true,
    isMenuItem: true,
  },
  {
    path: '/transactions',
    title: 'All Transactions',
    icon: <CheckIcon />,
    page: <AllTransactions />,
    verifiedUsersOnly: true,
    isMenuItem: true,
  },
  {
    path: '/platform-clients',
    title: 'Platform Clients',
    icon: <CorporateFareIcon />,
    page: <PlatformClients />,
    verifiedUsersOnly: true,
    isMenuItem: true,
  },
  {
    path: '/rates',
    title: 'Exchange Rates',
    icon: <SwapHorizIcon />,
    page: <ExchangeRates />,
    verifiedUsersOnly: true,
    isMenuItem: true,
  },
  {
    path: '/satellite-agents',
    title: 'Satellite Agents',
    icon: <GroupIcon />,
    page: <SatelliteAgents />,
    verifiedUsersOnly: true,
    isMenuItem: true,
  },
  {
    path: '/settings',
    title: 'Settings',
    icon: <SettingsApplicationsIcon />,
    page: <Settings />,
    verifiedUsersOnly: true,
    isMenuItem: true,
  },
  // {
  //   path: '/actions',
  //   title: 'Actions',
  //   icon: <SettingsApplicationsIcon />,
  //   page: <Actions />,
  //   verifiedUsersOnly: true,
  //   isMenuItem: true,
  // },
  { path: 'divider', verifiedUsersOnly: true, isMenuItem: true },
  {
    path: '/logout',
    title: 'Logout',
    icon: <ExitToAppIcon />,
    isMenuItem: true,
  },
  {
    path: '/platform-clients/details/:tenantId',
    title: 'Client Details',
    page: <PlatformClientDetails />,
    verifiedUsersOnly: true,
    isMenuItem: false,
  },
];

export default menuItems;
